import { TravelMethod } from '@modules/ticket-fares-store/client/src';
import { TicketSelectorPanelProps } from '@modules/ticket-search/components/ticket-accordion-panel/ticketSelectorPanelProps.interface';
import { RadioGroupProps } from '@nx-ng/types';
import { determineFareSelectorRadioOptions } from './format-option-common';

export const TRAVEL_METHOD_LOOKUP: RadioGroupProps<string> = {
  groupName: 'method',
  separatorLabelKey: 'other_operators',
  standard: [
    {
      titleKey: 'travel_method_nx_bus',
      value: '1',
      subTitleKey: 'travel_method_nx_bus_description',
    },
    {
      titleKey: 'travel_method_nx_bus_metro',
      value: '2',
    },
  ],
  additional: [
    {
      titleKey: 'travel_method_n_bus',
      value: '3',
      subTitleKey: 'travel_method_n_bus_description',
    },
    {
      titleKey: 'travel_method_n_bus_metro',
      value: '4',
      subTitleKey: 'travel_method_n_bus_metro_description',
    },
    {
      titleKey: 'travel_method_n_network',
      value: '5',
      subTitleKey: 'travel_method_n_network_description',
    },
    {
      titleKey: 'travel_method_west_midlands_metro',
      value: '6',
      subTitleKey: 'travel_method_west_midlands_metro_description',
    },
  ],
};

export const buildTravelMethodOptions = (
  methods: TravelMethod[] = [],
  selectedTravelMethod: string | undefined
): TicketSelectorPanelProps => {
  const methodIds =
    methods?.map((method: TravelMethod) => method.id || '') || [];

  const items: RadioGroupProps<string> = determineFareSelectorRadioOptions({
    allOptions: TRAVEL_METHOD_LOOKUP,
    validIds: methodIds,
    selectedValue: selectedTravelMethod,
  });

  return {
    category: 'method',
    selectKey: 'label_select_travel_method',
    radio: items,
    hasPanelInfoAction: true,
  };
};
